import { OlRateIdInput } from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { OlTeflPrice } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price'
import { OlTeflPriceInput } from '../../../lib/types/models/ol/tefl-price/ol-tefl-price-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateOlTeflPrice = async (data: Partial<OlTeflPriceInput> & OlRateIdInput) => {
  const { id, olId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.ols.updateOlTeflPrice.url, { id, olId }))
    .patch<OlTeflPrice, Partial<OlTeflPriceInput>>(rest)
}
